import { create } from "zustand";
import type { OrganizationCrossAccess } from "../types";

interface CrossAccessState {
	modalOpen: boolean;
	editingItem: OrganizationCrossAccess | null;
	defaultViewerId: string | null;
}

interface CrossAccessActions {
	openCreateModal: (defaultViewerId?: string) => void;
	openEditModal: (item: OrganizationCrossAccess) => void;
	closeModal: () => void;
}

type CrossAccessStore = CrossAccessState & CrossAccessActions;

export const useCrossAccessStore = create<CrossAccessStore>((set) => ({
	modalOpen: false,
	editingItem: null,
	defaultViewerId: null,

	openCreateModal: (defaultViewerId) => {
		set({ modalOpen: true, editingItem: null, defaultViewerId: defaultViewerId ?? null });
	},

	openEditModal: (item) => {
		set({ modalOpen: true, editingItem: item });
	},

	closeModal: () => {
		set({ modalOpen: false, editingItem: null, defaultViewerId: null });
	},
}));
